'use strict';

import { CurrencyConversion } from '../components/CurrencyConversion.js';
import { Form } from '../helpers/Form.js';

export class Donation {
	#form;
	#donationArray = [];
	#baseCurrency;
	#donationRates;
	#hideCurrencySwitcher;
	#donation_tribute_wrapper;
	#donation_tribute;

	constructor() {
		this.#form = document.querySelector(
			'form.levcharity_form.donation_form'
		);


		if ( ! this.#form ) {
			return;
		}

		this.#baseCurrency = this.#form.dataset.basecurrency;
		this.#hideCurrencySwitcher = this.#form.dataset.hideswitcher;
		this.#init();
	}

	async #init() {
		const donationForm = new Form();
		donationForm.setCurrencySymbolForDonationAmount( this.#form );

		donationForm.selectDonationAmount( this.#form, this.#donationArray );

		if ( ! this.#hideCurrencySwitcher ) {
			try {
				const currencyRates = new CurrencyConversion();
				this.#donationRates = await currencyRates.getConversionRates(
					this.#baseCurrency
				);
			} catch ( error ) {
				console.error( error.message );
			}
		}
		document.body.classList.add('loaded');
		donationForm.donationCurrencySwitcher(
			this.#form,
			this.#donationArray,
			this.#donationRates
		);
		donationForm.watchRecurringInputs( this.#form, this.#donationArray );
		donationForm.watchTributeCheckbox( this.#form );
		donationForm.watchCCFeeCheckbox( this.#form, this.#donationArray );
		donationForm.removeFromSummaryTable( this.#form, this.#donationArray );
		donationForm.preventSubmitByEnter();
		donationForm.cleanValidation( this.#form );
		donationForm.watchValidatedTributeInput(this.#form);

		const submitButton = this.#form.querySelector('.levcharity_form__primary_button.submit');
		donationForm.enableSubmit(submitButton);

		this.switchTabsByClicking();
		this.#form.addEventListener( 'submit', ( event ) => {
			event.preventDefault();


			this.#donation_tribute_wrapper = document.querySelector('.levcharity_form__field.donation_tribute_wrapper');
			if(this.#donation_tribute_wrapper){
				const computedStyle = window.getComputedStyle(this.#donation_tribute_wrapper);
					if (this.#donation_tribute_wrapper && computedStyle.display !== 'none') {
						const inputElements = this.#donation_tribute_wrapper.querySelectorAll('div input');
						const selectElements = this.#donation_tribute_wrapper.querySelectorAll('div select');
						let hasEmptyInput = false;

						inputElements.forEach((input) => {
							if (input.value.trim() === '') {
								input.style = 'border: 1px solid red !important';
								hasEmptyInput = true;
							} else {
								input.style = 'border: none';
							}
						});

						selectElements.forEach((select) => {
							if (select.value === 'default') {
								select.style = 'border: 1px solid red !important';
								hasEmptyInput = true;
							} else {
								select.style = 'border: none';
							}
						});

						let errorContainer = document.querySelector('.error-container');

						if (hasEmptyInput && !errorContainer) {
							errorContainer = document.createElement('div');
							errorContainer.className = 'error-container';

							const errorMessage = document.createElement('p');
							errorMessage.className = 'error-message';
							errorMessage.textContent = wp.i18n.__('Please fill out all required fields.', 'levcharity');
							errorContainer.appendChild(errorMessage);
							this.#donation_tribute_wrapper.parentNode.insertBefore(errorContainer, this.#donation_tribute_wrapper);
						} else if (!hasEmptyInput && errorContainer) {
							errorContainer.remove();
						}
					}
				}

			if ( this.#donationArray.length === 0 && !this.#form.querySelector('.donation_variations')) {
				donationForm.printValidation( this.#form, wp.i18n.__('You haven\'t add anything to your cart.', 'levcharity'));
			} else {
				//donationForm.testSubmissionData( this.#form );
				const tributeValidation = donationForm.validateTribute(this.#form);
				if (tributeValidation) {
					donationForm.submitForm( this.#form, 'send_donation_form', this.showErrorMessageInDonateForm, 'donation_form' );
				}
			}
		} );
	}

	showErrorMessageInDonateForm(responseData) {
		if(responseData.hasOwnProperty('success')) {
			if(responseData.success === false) {
				if(responseData.hasOwnProperty('message')) {
					if (document.body.classList.contains('ajax-loading')) {
						document.body.classList.remove('ajax-loading');
					}

					let errorMessage = document.querySelector('.donation-form-error-message');
					if(!errorMessage){
						errorMessage = document.createElement('p');
						errorMessage.style.color = 'red';
						errorMessage.style.textAlign = 'center';
						errorMessage.classList.add('donation-form-error-message');
					}

					errorMessage.innerText = responseData.message;
					let actionsContainer = document.querySelector('.levcharity_form__actions.levcharity_tabs__actions');
					if(actionsContainer) {
						let actionsContainerParent = actionsContainer.parentElement;
						if(actionsContainerParent){
							actionsContainerParent.prepend(errorMessage);

							window.scrollTo( {
								top: errorMessage.offsetTop,
								left: 0,
								behavior: 'smooth',
							} );
						}
					}
				}
			}
		}
	}

	switchTabsByClicking() {
		const switchToAmount = document.querySelector('.switch_to_amount');
		const amountNavItem = document.querySelector('.donation_amount_nav_item');
		const amountTab = document.querySelector('.donation_amount_tab');

		const switchToEquipment = document.querySelector('.switch_to_equipment');
		const equipmentNavItem = document.querySelector('.equipment_nav_item');
		const equipmentTab = document.querySelector('.donation_equipment_tab');


		switchToAmount?.addEventListener('click', () => {
			equipmentNavItem?.classList.remove('active');
			equipmentTab?.classList.remove('active');
			amountNavItem?.classList.add('active');
			amountTab?.classList.add('active');
		});

		switchToEquipment?.addEventListener('click', () => {
			amountNavItem?.classList.remove('active');
			amountTab?.classList.remove('active');
			equipmentNavItem?.classList.add('active');
			equipmentTab?.classList.add('active');
		})
	}
}
